<template>
  <section class="main-slider position-relative">
    <swiper
      class="main-slider-container"
      :options="swiperOption"
      @slideChange="changeSwiperIndex"
      ref="mySwiper"
    >
      <swiper-slide class="main-slider-item" v-for="(item, index) in data.mainslider" :key="index">
        <div class="swiper-slide-container" :style="{backgroundImage: 'url(' + item.img.url + ')'}">
          <b-container>
            <b-row class="h-100">
              <b-col cols="12" lg="7" offset-lg="1" class="h-100">
                <div class="content d-flex flex-column justify-content-center align-items-start">
                  <h2 class="title">{{item.title}}</h2>
                  <!--<button class="button" @click="$root.show">{{item.btn_text}}</button>-->
                  <div class="button-container" @click="$root.showCallback()">
                    <button-component class="normal-btn">Оформить заявку</button-component>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </swiper-slide>
    </swiper>
    <div class="position-absolute main-slider_nav-container">
      <b-container class="h-100">
        <b-row align-h="between" class="h-100">
          <b-col cols="1" lg="1" class="h-100 d-none d-lg-block">
            <div
              class="pagin-cont d-flex h-100 flex-column align-items-center justify-content-end justify-content-lg-center"
              slot="pagination"
            >
              <div class="curent">{{curentSlid}}</div>

              <div class="swiper-pagination-mainslider"></div>

              <div class="max">{{slidersCount}}</div>
            </div>
          </b-col>
          <b-col
            cols="1"
            class="h-100 d-none d-lg-flex flex-column align-items-center justify-content-center"
          >
            <div
              class="control-container-buttons d-flex justify-content-between align-items-center"
            >
              <div
                class="main-slider-swiper-button-prev d-flex justify-content-center align-items-center"
                slot="button-prev"
                style="transform: rotate(180deg)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="25"
                  viewBox="0 0 14 25"
                  fill="none"
                >
                  <path
                    d="M11.568 12.5407L0.711038 23.3977C0.444021 23.6647 0.444021 24.0929 0.711038 24.3599C0.978054 24.6269 1.40629 24.6269 1.6733 24.3599L13.0139 13.0193C13.281 12.7523 13.281 12.324 13.0139 12.057L1.6733 0.721414C1.54232 0.590424 1.36598 0.519893 1.19469 0.519893C1.0234 0.519893 0.847065 0.585387 0.716076 0.721413C0.44906 0.988431 0.44906 1.41666 0.716076 1.68368L11.568 12.5407Z"
                    fill="#00A65D"
                  />
                </svg>
              </div>
              <div
                class="main-slider-swiper-button-next d-flex justify-content-center align-items-center"
                slot="button-next"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="25"
                  viewBox="0 0 14 25"
                  fill="none"
                >
                  <path
                    d="M11.568 12.5407L0.711038 23.3977C0.444021 23.6647 0.444021 24.0929 0.711038 24.3599C0.978054 24.6269 1.40629 24.6269 1.6733 24.3599L13.0139 13.0193C13.281 12.7523 13.281 12.324 13.0139 12.057L1.6733 0.721414C1.54232 0.590424 1.36598 0.519893 1.19469 0.519893C1.0234 0.519893 0.847065 0.585387 0.716076 0.721413C0.44906 0.988431 0.44906 1.41666 0.716076 1.68368L11.568 12.5407Z"
                    fill="#00A65D"
                  />
                </svg>
              </div>
            </div>
          </b-col>
          <b-col cols="12" class="h-100 d-block d-lg-none">
            <div
              class="pagin-cont pagin-cont-m d-flex h-100 align-items-end justify-content-center"
            >
              <div class="d-flex align-items-center justify-content-center">
                <div class="curent m">{{curentSlid}}</div>

                <div class="swiper-pagination-mainsliderm"></div>

                <div class="max m">{{slidersCount}}</div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
const axios = require("axios");
export default {
  props: {
    link: String
  },
  data() {
    return {
      curentSlid: "01",
      slidersCount: "01",
      data: {},
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination-mainslider",
          type: "progressbar",
          progressbarOpposite: true
        },
        navigation: {
          nextEl: ".main-slider-swiper-button-next",
          prevEl: ".main-slider-swiper-button-prev"
        },
        breakpoints: {
          991: {
            pagination: {
              el: ".swiper-pagination-mainsliderm",
              type: "progressbar",
              progressbarOpposite: false
            }
          }
        }
      }
    };
  },
  beforeCreate() {
    axios
      .get(`${this.$root.routLink}/?ajax&act=mainSlider`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons);
        this.loaded = true;

        if (Object.keys(this.data.mainslider).length < 10) {
          this.slidersCount = "0" + Object.keys(this.data.mainslider).length;
        } else {
          this.slidersCount = Object.keys(this.data.mainslider).length;
        }
      });
  },
  mounted() {},
  methods: {
    btnClick() {
      if (this.link == "" || this.link == undefined) {
        this.$root.show();
      } else {
        window.open(this.link, "_self");
      }
    },
    changeSwiperIndex() {
      if (this.$refs.mySwiper.swiper.activeIndex + 1 < 10) {
        this.curentSlid = "0" + (this.$refs.mySwiper.swiper.activeIndex + 1);
      } else {
        this.curentSlid = this.$refs.mySwiper.swiper.activeIndex + 1;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.main-slider {
  z-index: 10;
  .main-slider-container {
    .main-slider-item {
      .swiper-slide-container {
        width: 100%;
        height: 456px;
        background-size: cover;
        background-repeat: no-repeat;
        .container {
          height: 100%;

          .content {
            height: 100%;
          }

          .title {
            font-weight: 500;
            font-size: 40px;
            line-height: 110.1%;
            margin-bottom: 35px;
            color: $defaultColor;
            @media only screen and (max-width: $md),
              only screen and (max-device-width: $md) {
              font-size: 30px;
              line-height: 120%;
            }
          }

          .button-container {
            width: 200px;
            height: 40px;
          }

          .button {
            background: #1be2ef;
            border-radius: 60px;
            color: #ffffff;
            border: none;
            font-size: 20px;
            line-height: 85.33%;
            padding: 20px 40px;
            outline: none;
            @media only screen and (max-width: $lg),
              only screen and (max-device-width: $lg) {
              width: 100%;
              margin-bottom: 110px;
            }
            &:hover,
            &:focus,
            &.hover {
              color: #ffffff;
              box-shadow: 0 0 7px 1px rgba(0, 240, 255, 0.75),
                0 0 5px 3px #00f0ff, inset 0 0 7px 1px rgba(0, 240, 255, 0.75),
                inset 0 0 5px 3px #00f0ff;
              animation: neon2 0.08s ease-in-out infinite alternate;
            }
          }
        }
      }
    }
  }
  &_nav-container {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
    z-index: 50;

    .curent {
      font-size: 20px;
      line-height: 24px;
      color: $activeColor;
      margin-bottom: 15px;
      &.m {
        margin: 0;
      }
    }
    .max {
      font-size: 20px;
      line-height: 24px;

      color: $defaultColor;
      margin-top: 15px;
      &.m {
        margin: 0;
      }
    }
    /*.pagin-cont-m {
				.swiper-pagination-mainslider {
					transform: rotate(-90deg);
				}
			}*/
    .control-container-buttons {
      pointer-events: all;
      width: 94px;
      height: 40px;
      background: rgba(20, 0, 0, 0.4);
      transform: rotate(90deg);
      // border: 1px solid #d08686;
      box-sizing: border-box;
      border-radius: 70px;
      .main-slider-swiper-button-next,
      .main-slider-swiper-button-prev {
        height: 100%;
        width: 50%;
        svg {
          path {
            transition: all 0.3s ease-in-out;
          }
        }
        &:hover svg {
          path {
            fill: #ffffff;
          }
        }
      }
    }
  }
}
</style>